import type { PropsWithChildren } from 'react'
import React, { createContext } from 'react'
import type { RouteComponentProps, match as matchType } from 'react-router-dom'
import { withRouter } from 'react-router-dom'
import { useLastLocation } from 'react-router-last-location'
import { generateMatch } from './LastMatchProvider.utils'

export type LastMatchType = {
  lastMatch: matchType
  currentMatch: matchType
}

export const LastMatchContext = createContext<LastMatchType>(null)

const LastMatchProvider: React.FC<PropsWithChildren & RouteComponentProps> = ({
  children,
  location
}) => {
  const lastLocation = useLastLocation()

  const lastMatch = generateMatch(lastLocation)
  const currentMatch = generateMatch(location)

  return (
    <LastMatchContext.Provider
      value={{
        lastMatch,
        currentMatch
      }}
    >
      {children}
    </LastMatchContext.Provider>
  )
}

export default withRouter(LastMatchProvider)
